import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  BulletList,
  DoDoNot,
} from './DocumentPage';
import CalorVesselsNotice from './CalorVesselsNotice';

const OvensDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Drying Ovens – Safe System of Work"
    documentHeading="Safe System of Work: Drying Ovens"
    meta={[
      ['Document Reference', 'PVS-SSOW-OVEN'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Activity', 'Use of drying ovens (for curing varnish, drying materials, equipment and components)'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Drying Ovens – Safe System of Work',
      documentReference: 'PVS-SSOW-OVEN',
      processActivity: 'Use of Drying Ovens',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <CalorVesselsNotice />

    <Section number="1" title="Introduction">
      <Paragraph>
        Drying ovens are commonly used for curing varnish or for drying materials, equipment and
        components. Drying ovens are safe to operate if used correctly as:
      </Paragraph>
      <BulletList
        className="mt-3"
        items={[
          'They are typically built like incinerators, so any fire will be safely contained.',
          'They eliminate the need for open flame or torch flame.',
        ]}
      />
      <Paragraph className="mt-3">
        Hazards associated with drying ovens include burns, electric shocks and manual handling
        injuries.
      </Paragraph>
    </Section>

    <Section number="2" title="Safe System of Work">
      <DoDoNot
        doItems={[
          'Carry out pre-use visual checks prior to using the oven. Any defects found should be immediately reported to the Manager or Supervisor. The oven should be taken out of service until repaired or replaced.',
          'Check safety devices such as pressure or limit switches to ensure they are fully operational.',
          'Place items carefully on the oven trolley, ensuring that the item will not fall or roll off.',
          'Before entering the oven ensure that the oven is turned off with the power isolated.',
          'Wear suitable PPE in the form of suitable heat resistant industrial type gloves.',
          'Where necessary lift items from the trolley using mechanical means such as an overhead crane.',
          'Push items in and out of the oven by hand.',
          'Always adopt a comfortable stance with feet apart so you feel well-balanced, to avoid manual handling injuries when loading / pushing workpieces.',
          'Ensure that the hands and feet of anyone loading the items are away from the door / hinge area before closing.',
          'When closing the oven door, pay attention to the limit switch on top of the door and ensure a connection is made.',
          'Check the temperature setting on the controller is as required.',
          'Ensure that the oven is turned off before opening.',
          'Check the area is clear before opening and removing any items from the oven.',
        ]}
        doNotItems={[
          'Open the oven door when the equipment is on.',
          'Open the door or remove items when others are working in the immediate vicinity.',
          'Handle any items without wearing suitable heat resistant gloves.',
          'Handle items in such a way as to risk manual handling injuries.',
          'Allow any untrained staff to operate or load / unload items into the oven.',
          'Place or leave any flammable items in the oven.',
          'Use the oven if you suspect a fault is present.',
          'Overfill the oven by heating numerous items at the same time.',
          'Carry out any maintenance to the oven unless trained to do so, and only if the oven is fully isolated and sufficiently cooled.',
        ]}
      />
    </Section>

    <Section number="3" title="Reminder">
      <Paragraph className="font-semibold">
        IF YOU HAVE ANY QUESTIONS, PLEASE ASK YOUR MANAGER OR SUPERVISOR. You have a duty not only
        to protect your own health and safety but also to ensure that your actions do not put others
        around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default OvensDoc;
